import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store';

export const selectProcessoArbitral = (state: RootState) => state.arbitralDetalhes.processo;
export const selectDocumentosArbitral = (state: RootState) => state.arbitralDetalhes.documentos;
export const selectLoadingDocumentos = (state: RootState) =>
  state.arbitralDetalhes.loadingDocumentos;
export const selectProcessoArbitralLoading = (state: RootState) => state.arbitralDetalhes.loading;
export const selectProcessoArbitralError = (state: RootState) => state.arbitralDetalhes.error;
export const selectCreatingParte = (state: RootState) => state.arbitralDetalhes.creatingParte;
export const selectPatchingParteId = (state: RootState) => state.arbitralDetalhes.patchingParteId;
export const selectReenvioParteId = (state: RootState) => state.arbitralDetalhes.reenvioParteId;
export const selectReabrindo = (state: RootState) => state.arbitralDetalhes.reabrindo;
export const selectSubmittingPendenciaId = (state: RootState) =>
  state.arbitralDetalhes.submittingPendenciaId;
export const selectRemovingDocumentoId = (state: RootState) =>
  state.arbitralDetalhes.removingDocumentoId;
export const selectLoadingAndamentos = (state: RootState) =>
  state.arbitralDetalhes.loadingAndamentos;
export const selectErrorAndamentos = (state: RootState) => state.arbitralDetalhes.errorAndamentos;
export const selectSubmittingAndamento = (state: RootState) =>
  state.arbitralDetalhes.submittingAndamento;
export const selectSendingMessage = (state: RootState) => state.arbitralDetalhes.sendingMessage;
export const selectMensagensChat = (state: RootState) => state.arbitralDetalhes.mensagensChat;
export const selectTypingUsers = (state: RootState) => state.arbitralDetalhes.typingUsers;
export const selectSituacoesDisponiveis = (state: RootState) =>
  state.arbitralDetalhes.situacoesDisponiveis;
export const selectGerenciandoSituacao = (state: RootState) =>
  state.arbitralDetalhes.gerenciandoSituacao;
export const selectSolicitacoes = (state: RootState) => state.arbitralDetalhes.solicitacoes;
export const selectLoadingSolicitacoes = (state: RootState) =>
  state.arbitralDetalhes.loadingSolicitacoes;
export const selectSubmittingSolicitacao = (state: RootState) =>
  state.arbitralDetalhes.submittingSolicitacao;
export const selectCancelandoProcesso = (state: RootState) =>
  state.arbitralDetalhes.cancelandoProcesso;

// Solicitações ainda em aberto (SOLICITADA) — base do selo "Solicitado" e do bloqueio de duplicata.
export const selectSolicitacoesAbertas = createSelector([selectSolicitacoes], (solicitacoes) =>
  solicitacoes.filter((s) => s.status === 'SOLICITADA'),
);
